/** Tenant (company) helpers — sprečavaju curenje poslova između firmi u Redux/UI. */

export const getCurrentCompanyId = () => {
  if (typeof window === 'undefined') return null;
  try {
    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    const result = profile?.result || profile;
    if (!result) return null;

    const userType = localStorage.getItem('userType') || 'company';
    if (userType === 'worker' || userType === 'partner') {
      return result.companyId ? String(result.companyId) : null;
    }
    return result._id ? String(result._id) : null;
  } catch {
    return null;
  }
};

export const jobBelongsToTenant = (job, companyId = getCurrentCompanyId()) => {
  if (!job || !companyId) return false;
  const cid = String(companyId);

  if (job.companyId && String(job.companyId) === cid) return true;
  if (job.sourceCompanyId && String(job.sourceCompanyId) === cid) return true;
  if (
    job.assignedPartnerCompanyId &&
    String(job.assignedPartnerCompanyId) === cid &&
    job.handoffStatus === 'pending_acceptance'
  ) {
    return true;
  }
  return false;
};

export const filterJobsForTenant = (jobs, companyId = getCurrentCompanyId()) => {
  if (!Array.isArray(jobs)) return [];
  if (!companyId) return jobs;
  return jobs.filter((job) => jobBelongsToTenant(job, companyId));
};

export const shouldApplyJobSocketPayload = (data) => {
  if (!data) return false;
  if (data.job && typeof data.job === 'object') {
    return jobBelongsToTenant(data.job);
  }
  return true;
};
